import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProcessSection } from './components/ProcessSection';
import { ContactForm } from './components/ContactForm';
import { FAQSection } from './components/FAQSection';
export function App() {
  return <div className="min-h-screen bg-[#000000] text-white font-sans selection:bg-[#50C878] selection:text-black scroll-smooth" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="pt-20" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <ProcessSection data-id="element-7" />
        <OfferSection data-id="element-8" />
        <ContactForm data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}